import importer from 'common/importer'
/* NAVIGATOR */
const { navigateCustom } = importer('NavigationService', null)
export default function * success ({ res }) {
  yield navigateCustom(res)
}
